<div class="view-column-container" [ngClass]="{'view-column-container--header-offset': true }">
  <!-- Description -->
  <app-view-column class="view-column-container__inner" @slideInOut *ngIf="columnVisible">
    <ng-container view-column-body>

      <!-- Default Content -->
      <ng-container *ngIf="!(quizModeActive$ | async)">
        <app-view-title></app-view-title>
        <app-view-content-mode layout="column"></app-view-content-mode>
      </ng-container>

      <!-- Quiz mode -->
      <app-view-quiz *ngIf="(quizModeActive$ | async)"></app-view-quiz>
    </ng-container>
  </app-view-column>

  <!-- Search -->
  <app-view-column class="view-column-container__inner" [unpadded]="true" @slideInOut *ngIf="searchVisible">
    <app-view-search></app-view-search>
  </app-view-column>

  <!-- Node Info -->
  <app-view-column class="view-column-container__inner" @slideInOut *ngIf="nodeInfoVisible">
    <app-view-node-description layout="column"></app-view-node-description>
  </app-view-column>
</div>